import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input
} from 'reactstrap';

interface DescriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave?: (desc: string) => void;
  initialValue?: string;
}

const DescriptionModal: React.FC<DescriptionModalProps> = ({ isOpen, onClose, onSave, initialValue }) => {
  const [desc, setDesc] = useState(initialValue || '');
  const [loading, setLoading] = useState(false);

  const handleSave = () => {
    if (onSave) {
      onSave(desc);
    }
    onClose();
  };

  const handleClear = () => {
    setDesc('');
  };

  const handleCancel = () => {
    setDesc(initialValue || '');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg">
      <ModalHeader toggle={onClose}>Description</ModalHeader>
      <ModalBody style={{ position: 'relative', minHeight: 300 }}>
        <Form>
          <FormGroup className="mb-0" style={{ position: 'relative' }}>
            <Input
              type="textarea"
              className="form-control bg-body"
              value={desc}
              onChange={e => setDesc(e.target.value)}
              rows={12}
              style={{ minHeight: 250, background: '#fff', resize: 'none' }}
              disabled={loading}
            />
            {loading && (
              <div className="d-flex justify-content-center align-items-center" style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, pointerEvents: 'none' }}>
                <span style={{ color: 'limegreen', fontSize: 24, display: 'block' }}>●</span>
              </div>
            )}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-soft-success btn-sm" style={{ minWidth: 80 }} onClick={handleSave} disabled={loading}>Save</button>
        <button className="btn btn-soft-danger btn-sm" style={{ minWidth: 80 }} onClick={handleClear} disabled={loading}>Clear</button>
        <button className="btn btn-soft-dark btn-sm" style={{ minWidth: 80 }} onClick={handleCancel} disabled={loading}>Cancel</button>
      </ModalFooter>
    </Modal>
  );
};

export default DescriptionModal; 